/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Cta_SearchInputs */

const es_exp_mk_cta_search = /** @type {(inputs: Exp_Mk_Cta_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar experiencias`)
};

const gl_exp_mk_cta_search = /** @type {(inputs: Exp_Mk_Cta_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar experiencias`)
};

const en_exp_mk_cta_search = /** @type {(inputs: Exp_Mk_Cta_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse experiences`)
};

/**
* | output |
* | --- |
* | "Browse experiences" |
*
* @param {Exp_Mk_Cta_SearchInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_cta_search = /** @type {((inputs?: Exp_Mk_Cta_SearchInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Cta_SearchInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_cta_search(inputs)
	if (locale === "en") return en_exp_mk_cta_search(inputs)
	return es_exp_mk_cta_search(inputs)
});